module.exports = __webpack_public_path__ + "img/9788934926917.f707d7cd.jpg";